"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var composeTypes_exports = {};
__export(composeTypes_exports, {
  composeDatePickerColorKeys: () => composeDatePickerColorKeys,
  composeTimePickerColorKeys: () => composeTimePickerColorKeys
});
module.exports = __toCommonJS(composeTypes_exports);
var composeDatePickerColorKeys = [
  "containerColor",
  "titleContentColor",
  "headlineContentColor",
  "weekdayContentColor",
  "subheadContentColor",
  "navigationContentColor",
  "yearContentColor",
  "disabledYearContentColor",
  "currentYearContentColor",
  "selectedYearContentColor",
  "disabledSelectedYearContentColor",
  "selectedYearContainerColor",
  "disabledSelectedYearContainerColor",
  "dayContentColor",
  "disabledDayContentColor",
  "selectedDayContentColor",
  "disabledSelectedDayContentColor",
  "selectedDayContainerColor",
  "disabledSelectedDayContainerColor",
  "todayContentColor",
  "todayDateBorderColor",
  "dayInSelectionRangeContentColor",
  "dayInSelectionRangeContainerColor",
  "dividerColor"
];
var composeTimePickerColorKeys = [
  "containerColor",
  "clockDialColor",
  "clockDialSelectedContentColor",
  "clockDialUnselectedContentColor",
  "selectorColor",
  "periodSelectorBorderColor",
  "periodSelectorSelectedContainerColor",
  "periodSelectorUnselectedContainerColor",
  "periodSelectorSelectedContentColor",
  "periodSelectorUnselectedContentColor",
  "timeSelectorSelectedContainerColor",
  "timeSelectorUnselectedContainerColor",
  "timeSelectorSelectedContentColor",
  "timeSelectorUnselectedContentColor"
];
//# sourceMappingURL=composeTypes.js.map
